// IconButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './IconButton.css';

// Icons
import Icon from 'svg/Icon';

/**
 * IconButton
 * 
 * A versatile icon button component that can display an icon.
 * 
 * @param
 * 
 * @returns {ReactNode} Button component.
 */
const IconButton = ({
    iconKey, 
    iconSize = 11, 
    size = 36,
    title, 
    color, 
    backgroundColor = 'transparent',
    onClick
}) => {

    // ----- CONTEXT ----- //

    const { theme } = useTheme();

    // ----- STATE ----- //

    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <button
          className="icon-button-container"
          style={{
                backgroundColor: hovered ? theme.buttonHoverBackgroundColor : backgroundColor,
                height: size,
                width: size,
            }}
          type="button"
          aria-label={title}
          title={title}
          onClick={onClick}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
            <Icon
              iconKey={iconKey}
              width={iconSize}
              height={iconSize}
              color={hovered ? theme.buttonHoverIconColor : color || theme.foregroundMuted}
            />
        </button>

    );
};

// Dev Tools
IconButton.displayName = 'IconButton';

export default IconButton;
